import { toast } from "react-toastify";
import { privateAxios } from "../../../config/apiConfig";
import { DELETE_VENDOR_FAILURE, DELETE_VENDOR_REQUEST, GET_VENDORS_FAILURE, GET_VENDORS_REQUEST, GET_VENDORS_SUCCESS, APPROVED_VENDOR_FAILURE, APPROVED_VENDOR_REQUEST, BLOCKED_VENDOR_FAILURE, BLOCKED_VENDOR_REQUEST, UNBLOCKED_VENDOR_FAILURE, UNBLOCKED_VENDOR_REQUEST, ADD_VENDOR_REQUEST, ADD_VENDOR_FAILURE, ADD_PENALTY_REQUEST, ADD_PENALTY_FAILURE, UPDATE_VENDOR_FAILURE, UPDATE_VENDOR_REQUEST, DELETE_VENDOR_SUCCESS } from "./ActionType";


export const getVendors = () => async (dispatch) => {
    dispatch({ type: GET_VENDORS_REQUEST })
    try {
        const { data } = await privateAxios.get(`admin/vendors`);
        dispatch({ type: GET_VENDORS_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: GET_VENDORS_FAILURE, payload: error.message })
    }
}

export const createVendor = (vendorData, handleCancle) => async (dispatch) => {
    dispatch({ type: ADD_VENDOR_REQUEST })
    try {
        const { data } = await privateAxios.post(`admin/vendor`, vendorData);
        if (data.status === "SUCCESS") {
            dispatch(getVendors())
            toast.success("Vendor Created Successfully")
            handleCancle();
        } else {
            toast.error(data.response || "Failed to add vendor.");
        }

    } catch (error) {
        toast.error(error.response?.data?.response || "An error occurred while Creating vendor.")
        dispatch({ type: ADD_VENDOR_FAILURE, payload: error.message })
    }
}

export const updateVendor = (vendorId, vendorData, handleCancle) => async (dispatch) => {
    dispatch({ type: UPDATE_VENDOR_REQUEST })
    try {
        const { data } = await privateAxios.put(`admin/vendor/${vendorId}`, vendorData);
        if (data.status === "SUCCESS") {
            dispatch(getVendors())
            toast.success("Vendor updated Successfully")
            handleCancle();
        } else {
            toast.error(data.response || "Failed to add vendor.");
        }

    } catch (error) {
        toast.error(error.response?.data?.response || "An error occurred while Creating vendor.")
        dispatch({ type: UPDATE_VENDOR_FAILURE, payload: error.message })
    }
}

export const addPenalty = (vendorId, penaltyPercentage) => async (dispatch) => {
    dispatch({ type: ADD_PENALTY_REQUEST })
    try {
        const { data } = await privateAxios.put(`admin/vendor/${vendorId}/penaltyPercentage/${penaltyPercentage}`);
        if (data.status === "SUCCESS") {
            dispatch(getVendors())
            toast.success("Penalty Added Successfully")
        } else {
            toast.error(data.response || "Failed to Add Penalty.");
        }

    } catch (error) {
        toast.error(error.response?.data?.response || "An error occurred while Adding Penalty.")
        dispatch({ type: ADD_PENALTY_FAILURE, payload: error.message })
    }
}

export const approvedVendor = (vendorId, setApproveDialogOpen) => async (dispatch) => {
    dispatch({ type: APPROVED_VENDOR_REQUEST })
    try {
        const { data } = await privateAxios.put(`admin/vendor/${vendorId}/approved`);
        if (data.status === "SUCCESS") {
            dispatch(getVendors())
            toast.success("Vendor Approved Successfully")
            setApproveDialogOpen(false)
        } else {
            toast.error(data.response || "Failed to Approved vendor.");
        }

    } catch (error) {
        toast.error(error.response?.data?.response || "An error occurred while Approving the vendor.")
        dispatch({ type: APPROVED_VENDOR_FAILURE, payload: error.message })
    }
}

export const pendingVendor = (vendorId, setApproveDialogOpen) => async (dispatch) => {
    dispatch({ type: APPROVED_VENDOR_REQUEST })
    try {
        const { data } = await privateAxios.put(`admin/vendor/${vendorId}/pending`);
        if (data.status === "SUCCESS") {
            dispatch(getVendors())
            toast.success("Vendor Pending Successfully")
            setApproveDialogOpen(false)
        } else {
            toast.error(data.response || "Failed to Approved vendor.");
        }

    } catch (error) {
        toast.error(error.response?.data?.response || "An error occurred while Approving the vendor.")
        dispatch({ type: APPROVED_VENDOR_FAILURE, payload: error.message })
    }
}


export const blockedVendor = (vendorId, setConfirmDialogOpen) => async (dispatch) => {
    dispatch({ type: BLOCKED_VENDOR_REQUEST })
    try {
        const { data } = await privateAxios.put(`admin/vendor/${vendorId}/blocked`);
        if (data.status === "SUCCESS") {
            dispatch(getVendors())
            toast.success("Vendor Blocked Successfully")
            setConfirmDialogOpen(false)
        } else {
            toast.error(data.response || "Failed to Approved vendor.");
        }

    } catch (error) {
        toast.error(error.response?.data?.response || "An error occurred while Approving the vendor.")
        dispatch({ type: BLOCKED_VENDOR_FAILURE, payload: error.message })
    }
}

export const unblockedVendor = (vendorId, setConfirmDialogOpen) => async (dispatch) => {
    dispatch({ type: UNBLOCKED_VENDOR_REQUEST })
    try {
        const { data } = await privateAxios.put(`admin/vendor/${vendorId}/unblocked`);
        if (data.status === "SUCCESS") {
            dispatch(getVendors())
            toast.success("Vendor Unblocked Successfully")
            setConfirmDialogOpen(false)
        } else {
            toast.error(data.response || "Failed to Approved vendor.");
        }

    } catch (error) {
        toast.error(error.response?.data?.response || "An error occurred while Approving the vendor.")
        dispatch({ type: UNBLOCKED_VENDOR_FAILURE, payload: error.message })
    }
}

export const deleteVendor = (vendorId, setOpenDialog) => async (dispatch) => {
    dispatch({ type: DELETE_VENDOR_REQUEST })
    try {
        const { data } = await privateAxios.delete(`vendor/vendor/${vendorId}`);
        if (data.status === "SUCCESS") {
            dispatch(getVendors())
            toast.success(data.response)
            dispatch({ type: DELETE_VENDOR_SUCCESS, payload: vendorId })
            setOpenDialog(false)
        }
    } catch (error) {
        toast.error(error.response?.data?.response || "An error occurred while deleting the vendor.")
        dispatch({ type: DELETE_VENDOR_FAILURE, payload: error.message })
    }
}